export default "__VITE_ASSET__DwR_nsWo__"